export default "__VITE_ASSET__d6955279__"